import { PropsWithChildren } from "react";

import { IconButton } from "@mui/material";

interface Props extends PropsWithChildren {
  ariaLabel: string;
  onClick: () => void;
}

export function CalendarNavigationIconButton({ ariaLabel, onClick, children }: Props) {
  return (
    <IconButton
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
      sx={{ p: 0, height: "100%", width: "50%", borderRadius: 0, "&:hover": { borderRadius: 0 } }}
      aria-label={ariaLabel}
    >
      {children}
    </IconButton>
  );
}
